import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { getCookie, loadScriptsSequentially } from "../utils";

function PartnerTerms() {
  return (
    <>
      <section className="page_breadcrumb">
        <div className="container">
          <div className="row">
            <div className="col-sm-7">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="https://psicopatici.com">Home</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/">Legal</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Termini & Condizioni
                  </li>
                </ol>
              </nav>
            </div>
            <div className="col-sm-5">
              <a href="#" className="date">
                <i className="icon_clock_alt"></i>Last update 1 week ago
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="doc_blog_grid_area sec_pad forum-single-content">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="q-title">
                {/* <span className="question-icon" title="Question">Q:</span> */}
                <h1>Termini & Condizioni</h1>
                {/* <a href="#" className="badge">Features</a> */}
              </div>
              <div className="forum-post-content">
                <div className="content">
                  <>
                    <style
                        type="text/css"
                        dangerouslySetInnerHTML={{
                          __html:
                              "\n    p.p1 {\n        margin: 0.0px 0.0px 0.0px 0.0px;\n        font: 14.0px 'Times New Roman'\n    }\n\n    p.p2 {\n        margin: 0.0px 0.0px 0.0px 0.0px;\n        font: 14.0px 'Times New Roman';\n        min-height: 16.0px\n    }\n\n    p.p3 {\n        margin: 0.0px 0.0px 0.0px 36.0px;\n        font: 14.0px 'Times New Roman'\n    }\n\n    p.p4 {\n        margin: 0.0px 0.0px 0.0px 36.0px;\n        font: 14.0px 'Times New Roman';\n        min-height: 16.0px\n    }\n\n    span.Apple-tab-span {\n        white-space: pre\n    }\n"
                        }}
                    />
                    <style
                        type="text/css"
                        dangerouslySetInnerHTML={{
                          __html:
                              "\n    p.p1 {\n        margin: 0.0px 0.0px 0.0px 0.0px;\n        font: 12.0px Times\n    }\n"
                        }}
                    />
                    <style
                        type="text/css"
                        dangerouslySetInnerHTML={{
                          __html:
                              "\n    p.p1 {\n        margin: 0.0px 0.0px 0.0px 0.0px;\n        font: 12.0px Times\n    }\n"
                        }}
                    />
                    <style
                        type="text/css"
                        dangerouslySetInnerHTML={{
                          __html:
                              "\n    p.p1 {\n        margin: 0.0px 0.0px 0.0px 0.0px;\n        font: 14.0px 'Times New Roman'\n    }\n\n    p.p2 {\n        margin: 0.0px 0.0px 0.0px 0.0px;\n        font: 14.0px 'Times New Roman';\n        min-height: 16.0px\n    }\n\n    p.p3 {\n        margin: 0.0px 0.0px 0.0px 36.0px;\n        font: 14.0px 'Times New Roman'\n    }\n\n    p.p4 {\n        margin: 0.0px 0.0px 0.0px 36.0px;\n        font: 14.0px 'Times New Roman';\n        min-height: 16.0px\n    }\n\n    span.Apple-tab-span {\n        white-space: pre\n    }\n"
                        }}
                    />
                    <p>
                      <strong>Termini e Condizioni di Collaborazione – Partner Digitale</strong>
                    </p>
                    <p>
                      Registrandosi all’area riservata del sito psicopatici.com in qualità di{" "}
                      <strong>Partner Digitale</strong>, l’utente accetta i seguenti Termini e
                      Condizioni che regolano la collaborazione con{" "}
                      <strong>Psicopatici Italia S.r.l.</strong>, con sede legale in Napoli (NA),
                      Via Ferrante Imparato n. 190 – CAP 80146, C.F. e P.IVA 08842551213 (di
                      seguito “la Società”).
                    </p>
                    <p>
                      <br />
                    </p>
                    <p>
                      <strong>1. Oggetto della Collaborazione</strong>
                    </p>
                    <p>Registrandosi come Partner Digitale, l’utente accetta di:</p>
                    <p>
                      &nbsp; &nbsp; • &nbsp; &nbsp;condividere contenuti digitali forniti o
                      approvati dalla Società su social media, app di messaggistica e altri canali
                      digitali per promuovere il marchio “Psicopatici Italia”;
                    </p>
                    <p>
                      &nbsp; &nbsp; • &nbsp; &nbsp;promuovere i prodotti e i servizi offerti dalla
                      Società;
                    </p>
                    <p>
                      &nbsp; &nbsp; • &nbsp; &nbsp;creare una rete di altri Partner Digitali e
                      ricevere commissioni sugli acquisti generati dalla propria rete.
                    </p>
                    <p>Il Partner potrà:</p>
                    <p>
                      &nbsp; &nbsp; • &nbsp; &nbsp;acquisire clienti diretti e maturare
                      commissioni sugli acquisti da loro effettuati;
                    </p>
                    <p>
                      &nbsp; &nbsp; • &nbsp; &nbsp;costruire una rete di altri Partner Digitali e
                      maturare commissioni indirette sulle vendite generate da questi ultimi.
                    </p>
                    <p>Il Partner Digitale si impegna a:</p>
                    <p>
                      &nbsp; &nbsp; • &nbsp; &nbsp;produrre contenuti coerenti con l’identità del
                      marchio;
                    </p>
                    <p>
                      &nbsp; &nbsp; • &nbsp; &nbsp;utilizzare solo materiali autorizzati o forniti
                      dalla Società;
                    </p>
                    <p>
                      &nbsp; &nbsp; • &nbsp; &nbsp;autorizzare, se richiesto, la pubblicazione di
                      contenuti a proprio nome da parte della Società (es. campagne di marketing
                      automatico).
                    </p>
                    <p>
                      <br />
                    </p>
                    <p>
                      <strong>2. Durata</strong>
                    </p>
                    <p>
                      La collaborazione ha durata di 12 mesi dalla data di registrazione.
                      <br />
                      Alla scadenza:
                    </p>
                    <p>
                      &nbsp; &nbsp; • &nbsp; &nbsp;potrà essere prorogata, anche tacitamente,
                      salvo revoca scritta da parte della Società;
                    </p>
                    <p>
                      &nbsp; &nbsp; • &nbsp; &nbsp;eventuali commissioni già maturate o maturande
                      restano acquisite dal Partner Digitale.
                    </p>
                    <p>
                      <br />
                    </p>
                    <p>
                      <strong>3. Commissioni</strong>
                    </p>
                    <p>Il Partner ha diritto a ricevere commissioni su due livelli:</p>
                    <p>
                      <strong>Clienti Diretti</strong>
                    </p>
                    <p>Per ogni acquisto effettuato da un cliente acquisito direttamente:</p>
                    <p>
                      &nbsp; &nbsp; • &nbsp; &nbsp;Commissione di appartenenza:{" "}
                      <strong>3%</strong>
                    </p>
                    <p>
                      &nbsp; &nbsp; • &nbsp; &nbsp;Commissione di vendita diretta:{" "}
                      <strong>6%</strong>
                      <br />
                      <strong>Totale iniziale: 9%</strong>
                    </p>
                    <p>Progressioni provvigionali:</p>
                    <p>
                      &nbsp; &nbsp; • &nbsp; &nbsp;Dal 51° acquisto in poi:{" "}
                      <strong>12% (4% + 8%)</strong>
                    </p>
                    <p>
                      &nbsp; &nbsp; • &nbsp; &nbsp;Dal 301° acquisto in poi:{" "}
                      <strong>15% (5% + 10%)</strong>
                    </p>
                    <p>
                      &nbsp; &nbsp; • &nbsp; &nbsp;Dal 1001° acquisto in poi:{" "}
                      <strong>18% (6% + 12%)</strong>
                    </p>
                    <p>
                      <em>
                        Nota: Se un acquisto è concluso da un altro Partner o direttamente dalla
                        Società, sarà riconosciuta solo la commissione di appartenenza, se
                        spettante.
                      </em>
                    </p>
                    <p>
                      Il Partner può scegliere di rinunciare in parte o totalmente alla
                      commissione di vendita diretta per offrire sconti ai clienti. Tale importo
                      sarà automaticamente convertito in sconto, visibile in sede di
                      rendicontazione.
                    </p>
                    <p>
                      <br />
                    </p>
                    <p>
                      <strong>Rete di Partner Digitali</strong>
                    </p>
                    <p>
                      Per ogni acquisto generato da clienti appartenenti ai partner legati alla
                      rete diretta del Partner:
                    </p>
                    <p>
                      &nbsp; &nbsp; • &nbsp; &nbsp;Commissione di rete: <strong>3%</strong>{" "}
                      dell’imponibile netto.
                    </p>
                    <p>
                      Le commissioni verranno calcolate e liquidate su base trimestrale. Entro 30
                      (trenta) giorni dal termine di ciascun trimestre solare, il Partner
                      trasmetterà alla Società una rendicontazione dettagliata delle commissioni
                      maturate, unitamente alla relativa fattura. Il pagamento della fattura
                      avverrà entro 30 giorni F.M.
                    </p>
                    <p>
                      Il Partner può richiedere l’accredito della commissione a partire da un
                      minimo di €50
                    </p>
                    <p>
                      <br />
                    </p>
                    <p>
                      <strong>4. Bonus Registrazione Clienti</strong>
                    </p>
                    <p>
                      Il Partner ha diritto a un bonus di <strong>€0,50</strong> per ogni nuova
                      registrazione utente alla piattaforma effettuata tramite:
                    </p>
                    <p>&nbsp; &nbsp; • &nbsp; &nbsp;link personalizzati,</p>
                    <p>&nbsp; &nbsp; • &nbsp; &nbsp;QR code,</p>
                    <p>&nbsp; &nbsp; • &nbsp; &nbsp;banner o strumenti digitali tracciabili.</p>
                    <p>
                      Il bonus è riconosciuto sotto forma di{" "}
                      <strong>credito non convertibile</strong>, utilizzabile per:
                    </p>
                    <p>
                      &nbsp; &nbsp; • &nbsp; &nbsp;acquisti nello store di Psicopatici Italia,
                    </p>
                    <p>
                      &nbsp; &nbsp; • &nbsp; &nbsp;creazione di coupon o sconti da offrire a
                      clienti/terzi.
                    </p>
                    <p>
                      <strong>Limite massimo</strong>: €500,00 (pari a 1.000 registrazioni
                      valide).
                    </p>
                    <p>
                      In caso di comportamenti fraudolenti, la Società si riserva il diritto di
                      annullare la collaborazione con effetto immediato e richiedere la
                      restituzione di eventuali bonus o commissioni indebite.
                    </p>
                    <p>
                      <br />
                    </p>
                    <p>
                      <strong>5. Obblighi del Partner Digitale</strong>
                    </p>
                    <p>Il Partner si impegna a:</p>
                    <p>
                      &nbsp; &nbsp; • &nbsp; &nbsp;promuovere attivamente la piattaforma e i
                      prodotti della Società;
                    </p>
                    <p>
                      &nbsp; &nbsp; • &nbsp; &nbsp;supportare i clienti e i Partner Digitali
                      acquisiti;
                    </p>
                    <p>
                      &nbsp; &nbsp; • &nbsp; &nbsp;mantenere aggiornate le proprie attività con la
                      Società;
                    </p>
                    <p>
                      &nbsp; &nbsp; • &nbsp; &nbsp;rispettare le linee guida comunicative e
                      operative.
                    </p>
                    <p>
                      <br />
                    </p>
                    <p>
                      <strong>6. Obblighi della Società</strong>
                    </p>
                    <p>La Società si impegna a:</p>
                    <p>
                      &nbsp; &nbsp; • &nbsp; &nbsp;fornire strumenti digitali per l’attività del
                      Partner;
                    </p>
                    <p>
                      &nbsp; &nbsp; • &nbsp; &nbsp;mettere a disposizione materiali marketing
                      preconfezionati;
                    </p>
                    <p>
                      &nbsp; &nbsp; • &nbsp; &nbsp;attivare campagne di marketing automatizzate in
                      supporto alle attività del Partner.
                    </p>
                    <p>
                      <br />
                    </p>
                    <p>
                      <strong>7. Non Esclusività</strong>
                    </p>
                    <p>
                      La collaborazione non è in esclusiva. La Società si riserva il diritto di
                      collaborare con altri Partner Digitali anche nella stessa area geografica.
                    </p>
                    <p>
                      <br />
                    </p>
                    <p>
                      <strong>8. Foro Competente</strong>
                    </p>
                    <p>
                      Per qualsiasi controversia legata a questi Termini e Condizioni sarà
                      competente in via esclusiva il Foro di Napoli.
                    </p>
                  </>

                </div>
              </div>
            </div>

            {/* <div className="col-lg-4">
                            <div className="forum_sidebar">
                                <div className="widget status_widget">
                                    <h4 className="c_head">Information</h4>
                                    <p className="status">Support is <span className="offline">Offline</span></p>
                                    <div className="open-hours">
                                        <h4 className="title-sm">Our office hours</h4>
                                        <p>
                                            Monday - Friday / 10am - 6pm (UTC +4) NewYork
                                        </p>
                                        <ul className="current-time list-unstyled">
                                            <li>
                                                <h4 className="title-sm">Your time</h4>
                                                <p>10:30:15 PM</p>
                                            </li>
                                            <li>
                                                <h4 className="title-sm">Your time</h4>
                                                <p>10:30:15 PM</p>
                                            </li>
                                        </ul>
                                    </div>

                                </div>

                                <div className="widget usefull_links_widget">
                                    <h4 className="c_head">Usefull Links</h4>

                                    <ul className="list-unstyled usefull-links">
                                        <li><i className="icon_lightbulb_alt"></i><a href="#">FAQs</a></li>
                                        <li><i className="icon_clock_alt"></i><a href="#">Popular</a></li>
                                        <li><i className="icon_piechart"></i><a href="#">Recent</a></li>
                                        <li><i className="icon_info_alt"></i><a href="#">Unanswered</a></li>
                                    </ul>
                                </div>
                                <div className="widget ticket_widget">
                                    <h4 className="c_head">Ticket Categories</h4>

                                    <ul className="list-unstyled ticket_categories">
                                        <li><img src="img/home_support/cmm5.png" alt="category" /><a href="#">Docs WordPress
                                            Theme</a> <span className="count">10</span></li>
                                        <li><img src="img/home_support/cmm4.png" alt="category" /><a href="#">Product Landing
                                            Page</a><span className="count count-fill">13</span><span
                                                className="count">54</span></li>
                                        <li><img src="img/home_support/cmm2.png" alt="category" /><a href="#">Knowledge base
                                            Template</a><span className="count">142</span></li>
                                        <li><img src="img/home_support/cmm8.png" alt="category" /><a href="#">Startup and App
                                            WP Theme</a> <span className="count">13</span></li>
                                        <li><img src="img/home_support/cmm9.png" alt="category" /><a href="#">Clean Email
                                            Template</a> <span className="count">123</span></li>
                                        <li><img src="img/home_support/cmm10.png" alt="category" /><a href="#">Apps WordPress
                                            Theme</a> <span className="count">18</span></li>
                                    </ul>
                                </div>

                                <div className="widget tag_widget">
                                    <h4 className="c_head">Tags</h4>
                                    <ul className="list-unstyled w_tag_list style-light">
                                        <li><a href="#">Swagger</a></li>
                                        <li><a href="#">KbDoc</a></li>
                                        <li><a href="#">weCare</a></li>
                                        <li><a href="#">Business</a></li>
                                        <li><a href="#">Download</a></li>
                                        <li><a href="#">Doc</a></li>
                                        <li><a href="#">WordPress</a></li>
                                        <li><a href="#">Design</a></li>
                                        <li><a href="#">ui/ux</a></li>
                                        <li><a href="#">Doc Design</a></li>
                                        <li><a href="#">DocAll</a></li>
                                        <li><a href="#">Productboard</a></li>
                                        <li><a href="#">Magento</a></li>
                                    </ul>
                                </div>

                            </div>
                        </div> */}
          </div>
        </div>
      </section>
    </>
  );
}

export default PartnerTerms;
